import React from 'react';
import { Button } from '@material-ui/core';
import withStyles from "@material-ui/core/styles/withStyles";

import buttonsStyle from "assets/jss/material-dashboard-pro-react/views/buttonsStyle.jsx";

class ButtonGroupSelect extends React.Component {

    constructor(props) {
        super(props);

        this.isMulti = props.isMulti;

        this.state = {
            selectedOption: props.value ? props.value : props.options[0],
            selectedMultiple: props.value ? props.value : [props.options[0]]
        }
    }

    isMulti;

    UNSAFE_componentWillReceiveProps(newProps) {
        if (this.isMulti && this.state.selectedMultiple && (newProps.value || newProps.allowNull)) {
            if (newProps.value.length !== this.state.selectedMultiple.length) {
                this.setState({ selectedMultiple: newProps.value });
            }
        } else {
            if (newProps.value !== this.state.selectedOption || newProps.value !== this.props.value) {
                this.setState({ selectedOption: newProps.value });
            }
        }
    }

    render() {

        const { classes, allowNull, value, onChange, ...rest } = this.props;

        return (
            <div className={classes.buttonGroup} style={{ ...this.props.containerStyle }}>
                {
                    this.props.options.map((x, i, options) => {

                        var classToUse = classes.middleButton;

                        if (options.length - 1 === i) {
                            classToUse = classes.lastButton;
                        }
                        else if (i === 0) {
                            classToUse = classes.firstButton
                        }

                        return (
                            <Button
                                key={x}
                                onClick={() => {
                                    if (this.isMulti) {
                                        var newSelectedState = this.state.selectedMultiple.concat([]);
                                        if (
                                            this.state.selectedMultiple.includes(x)
                                            &&
                                            (
                                                allowNull && this.state.selectedMultiple.length >= 1
                                                ||
                                                !allowNull && this.state.selectedMultiple.length > 1
                                            )
                                        ) {
                                            newSelectedState = newSelectedState.filter(y => y !== x);
                                        } else if (!this.state.selectedMultiple.includes(x)) {
                                            newSelectedState.push(x);
                                        }

                                        this.setState({ selectedMultiple: newSelectedState }, () => {
                                            if (onChange)
                                                onChange(newSelectedState)
                                        });
                                    }
                                    else {
                                        var newState = x;
                                        if (allowNull && this.state.selectedOption === x)
                                            newState = null;

                                        this.setState({ selectedOption: newState }, () => {
                                            if (onChange)
                                                onChange(newState)
                                        });
                                    }
                                }}
                                className={classToUse}
                                variant={(this.isMulti ? this.state.selectedMultiple.includes(x) : this.state.selectedOption === x) ? 'contained' : 'outlined'}
                                color={this.props.color || "primary"}>
                                {x.toUpperCase()}
                            </Button>
                        );
                    })
                }
            </div>
        );
    }
}

export default withStyles(buttonsStyle)(ButtonGroupSelect);